import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody,
} from "../../APIHelpers/Responses";

function getRuntimeConfig() {
  const w = typeof window !== "undefined" ? window : null;
  const runtime = (w && w.SitePilotChatWidgetConfig) ? w.SitePilotChatWidgetConfig : {};
  return { ...config, ...runtime };
}

export const widgetServices = {
  addNewWidget,
  addUpdateWidget,
  deleteWidget,
  getWidgetList,
  getWidgetDetails,
  getWidgetChatData
};

// Add New Widget
async function addNewWidget(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewWidget`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Add Update Widget
async function addUpdateWidget(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateWidget`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Widget
async function deleteWidget(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteWidget`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get Widget List
async function getWidgetList() {
  try {
    const signal = cancelPreviousRequest(`getWidgetList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getWidgetList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Widget Details
async function getWidgetDetails(widgetId) {
  try {
    const signal = cancelPreviousRequest(`getWidgetDetails`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getWidgetDetails/${widgetId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Widget Chat Form
async function getWidgetChatData(widgetId, widgetType) {
  try {
    const cfg = getRuntimeConfig();
    const signal = cancelPreviousRequest(`getWidgetChatData`);
    const apiURL = `${cfg.API_URL_USER_ONBOARDING}getWidgetChatData/${widgetId}/${widgetType}`;

    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET", headers),
      signal
    });

    const result = await response.json();
    const data = decryptResponse(result);

    if (data?.statusCode === 401) handleResponse(data);
    return data;
  } catch (err) {
    if (err.name === "AbortError") return "AbortError";
    throw err;
  }
}